import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3 8.25h12v1.5H3z" }));
export default SvgMinus;
